import * as Highcharts from 'highcharts';
import {Chart, Options, AxisLabelsFormatterContextObject} from 'highcharts';

export default abstract class AbstractChart {
    protected target: HTMLElement;

    constructor(target: HTMLElement) {
        this.target = target;
    }

    public createChart(): Chart {
        return Highcharts.chart(this.target, this.preCreationOptions());
    }

    /**
     * Returns options added to all charts (as opposed to only longitudinal charts) of the respective plugin.
     *
     * NOTE: Don't set shared Highcharts options in the abstract class here, but as 'defaultOptions' in charts.ts which uses a specific Highcharts way to share global options.
     *
     * See also 'setDefaultOptions' in charts.ts if you want to override global options.
     */
    protected allChartOptions(): Options {
        return {};
    }

    /**
     * Returns options added specifically to longitudinal charts of the respective plugin.
     */
    protected longitudinalChartOptions(): Options {
        return {
            xAxis: {
                tickInterval: 1,
                labels: {
                    formatter: function (this: AxisLabelsFormatterContextObject) {
                        return `t${this.pos + 1}`;
                    }
                }
            }
        };
    }

    /**
     * Returns all merged options that are going to be used for the actual chart creation in the next step.
     *
     * Accessing all merged options can be used in a child plugin e.g. to add a new option that depends on an existing one.
     */
    protected preCreationOptions(): Options {
        return this.mergeOptions(
            this.allChartOptions(),
            this.isLongitudinal() ? this.longitudinalChartOptions() : {},
            $(this.target).data('options')
        );
    }

    protected isLongitudinal(): boolean {
        return $(this.target).data('isLongitudinal');
    }

    protected mergeOptions(a: object, ...n: object[]): Options {
        return Highcharts.merge(a, ...n);
    }
}